import React, { useEffect, useState } from 'react'
import { Form } from 'react-router-dom';
import ReactSelect from 'react-select';
import SuccessToast from '../SuccessToast';
import WarningToast from '../WarningToast';
import ErrorToast from '../ErrorToast';
import axios from '../../API/axios';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import WarningSharpIcon from '@mui/icons-material/WarningSharp';
import ErrorSharpIcon from '@mui/icons-material/ErrorSharp';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import LockSharpIcon from '@mui/icons-material/LockSharp';
import { useTranslation } from 'react-i18next';
import useNewsFeedStore from '../NewsFeed/useNewsFeedStore';
import WljConfirmModal from '../../components/WljConfirmModal';
import WljOverlayModal from '../../components/WljOverlayModal';
const Account = () => {
    const sessionId = localStorage.getItem("sessionId");
    const userUid = localStorage.getItem("userUid");
    const firstName = localStorage.getItem("firstName");
    const lastName = localStorage.getItem("lastName");
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };
    const options = [
        { value: "Mumbai", label: "Mumbai" },
        { value: "Thane", label: "Thane" },
        { value: "Pune", label: "Pune" },
    ];

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);
  const language = localStorage.getItem("Lang");
    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);
    /************************Deactivate Account   ************************/
    const [show, setShow] = useState(false);
    const DeactivateAccount = () => {
        setShow(false);
    };

    const DeactivateAcc = async () => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
            langKey: language === "en" ? "" : language,
        };
        try {
            await axios.post(`Account/DeactivateAccount`, responseData).then(() => {
                setShow(!show);
                console.log('res', responseData);
                // setToastMessage(responseData.data.message);
                // setShowToast(true);
            });
        } catch (error) {
            console.log('error', error);
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }
    };
    /************************Deactivate Account   ************************/
    /************************Delete Account   ************************/
    const [showDelete, setShowDelete] = useState(false);
    const DeleteAccount = () => {
        setShowDelete(false);
    };

    const DeleteAcc = async () => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
            langKey: language === "en" ? "" : language,
        };
        try {
            await axios.post(`Account/DeleteAccount`, responseData).then(() => {
                setShow(!show);
                console.log('res', responseData);
                setToastMessage(responseData.data.message);
                setShowToast(true);
            });
        } catch (error) {
            console.log('error', error);
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }
    };
    /************************Delete Account   ************************/
    useEffect(() => {
        if (show || showDelete || showModal) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
            document.body.classList.add('modal-open'); // When a modal opens
        } else {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = '';
            document.body.classList.remove('modal-open'); // When a modal closes
        }
    }, [show, showDelete, showModal]);


  const [Textvalue1, setTextvalue1] = useState(`You’re about to initiate the activity of deactivating your WELINKJOBS account, ${firstName} ${lastName} with ID ${userUid}, and your public profile will be no longer accessible or viewable on Welinkjobs.com, Welinkjobs for Android, or Welinkjobs for iOS. After again your successful login deactivated account will be activated and accessible or viewable on Welinkjobs.com`);
  const [Textvalue2, setTextvalue2] = useState(`After again your successful login deactivated account will be activated and accessible or viewable on <a href='https://welinkjobs.com'>Welinkjobs.com</a>`);
  const [Textvalue3, setTextvalue3] = useState(`You’re about to initiate the activity of deactivating your WELINKJOBS account, ${firstName} ${lastName} with ID ${userUid}, and your public profile will be no longer accessible or viewable on Welinkjobs.com, Welinkjobs for Android, or Welinkjobs for iOS. After again your successful login deactivated account will be activated and accessible or viewable on Welinkjobs.com`);
  const [Textvalue4, setTextvalue4] = useState(`You’re about to initiate the activity of deactivating your WELINKJOBS account, ${firstName} ${lastName} with ID ${userUid}, and your public profile will be no longer accessible or viewable on Welinkjobs.com, Welinkjobs for Android, or Welinkjobs for iOS. After again your successful login deactivated account will be activated and accessible or viewable on Welinkjobs.com`);

//   const TextTranslate = async () => {
        
//         try {
//             await axios.get(`General/TextTranslateAsync?Text=${Textvalue1}&ToLanguageCode=${language}`).then(() => {
//              axios.get(`General/TextTranslateAsync?Text=${Textvalue1}&ToLanguageCode=${language}`).then(() => {
//                 // setShow(!show);
//                 console.log('res', ); 
//             });
//             });
//         } catch (error) {
//             console.log('error', error);

//         }
//     };

const TextTranslate = async () => {
  try {
    const urls = [
      `General/TextTranslateAsync?Text=${encodeURIComponent(Textvalue1)}&ToLanguageCode=${language}`,
      `General/TextTranslateAsync?Text=${encodeURIComponent(Textvalue2)}&ToLanguageCode=${language}`,
      ];

    // Fire all 4 requests in parallel
    const responses = await Promise.all(urls.map(url => axios.get(url)));

    // Log or set the translated text
    console.log("Translation results:", responses.map(res => res.data));
 
  } catch (error) {
    console.error("Translation error:", error);
  }
};
const TextTranslate1 = async () => {
  try {
    const urls = [
      `General/TextTranslateAsync?Text=${encodeURIComponent(Textvalue3)}&ToLanguageCode=${language}`,
      `General/TextTranslateAsync?Text=${encodeURIComponent(Textvalue4)}&ToLanguageCode=${language}`,
    ];

    // Fire all 4 requests in parallel
    const responses = await Promise.all(urls.map(url => axios.get(url)));

    // Log or set the translated text
    console.log("Translation results:", responses.map(res => res.data));
 
  } catch (error) {
    console.error("Translation error:", error);
  }
};

 // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------


    return (
        <>
            <div className='pb-1'>
                <div className='setting-header'>
                    <h4>{t("User Profile.Manage Account")}</h4>
                </div>
                <div className='p-3 deactivate'  style={{
                    direction: language === "ar" ? "rtl" : "ltr",
                    textAlign: language === "ar" ? "right" : "left"
                }}>
                    <div className='d-flex mb-3 align-items-center justify-content-between'>
                        <div>
                        <ErrorSharpIcon className="material-symbols-sharp" />
                        <span className='cardHeader'> {t("User Profile.Deactivate your account")}</span>
                        </div>
                        {/* <span onClick={ () => TextTranslate()} className='pointer' style={{color:'blue !important', borderBottom: '1px solid'}}>Translate</span> */}
                    </div>
                    <div>
                        <span > {t("User Profile.This will deactivate your account")}</span>
                        <ul className='mt-3'>
                            <li>{t("User Profile.You’re about to initiate the activity of deactivating your WELINKJOBS account,")} {firstName} {lastName} {t("User Profile.with ID")} {userUid}, 
                                {t("User Profile.and your public profile will be no longer accessible or viewable on Welinkjobs.com, Welinkjobs for Android, or Welinkjobs for iOS.")} </li>
                            <li>{t("User Profile.After again your successful login deactivated account will be activated and accessible or viewable on")} <a href='https://welinkjobs.com'>Welinkjobs.com</a> </li>
                        </ul>
                    </div>
                    <div className='text-end'>
                        <button className='deactivatebtn cardHeader' onClick={() => {
                            setShow(!show);
                        }}> {t("User Profile.Deactivate account")}</button>
                    </div>
                </div>
                <div className='p-3 closeAccount'  
                style={{
                        direction: language === "ar" ? "rtl" : "ltr",
                        textAlign: language === "ar" ? "right" : "left"
                    }}
                    >
                    <div className='d-flex mb-3 align-items-center justify-content-between'>
                        <div>
                        <WarningSharpIcon className="material-symbols-sharp" />
                        <span className='cardHeader'>{t("User Profile.Delete your account")}</span>
                        </div>
                        {/* <span onClick={ () => TextTranslate1()} className='pointer' style={{color:'blue !important', borderBottom: '1px solid'}}>Translate</span> */}

                    </div>
                    <div>
                        <span >{t("User Profile.This will Delete your account")}</span>
                        <ul className='mt-3'>
                            <li>{t("User Profile.You’re about to initiate the activity of deleting your WELINKJOBS account,")} {firstName} {lastName}{t("User Profile.with ID")} {userUid},
                               {t("User Profile.and your public profile will be no longer available on Welinkjobs.com, Welinkjobs for Android, or Welinkjobs for iOS.")}</li>
                            <li>{t("User Profile.You can restore your WELINKJOBS account if it was by mistake deleted for up to 45 days after deletion.")}
                            </li>
                            {/* <li>You can restore your X account if it was accidentally or wrongfully deactivated for up to 30 days after deactivation.</li> */}
                        </ul>
                    </div>
                    <div className='text-end'>
                        <button className='deletAccntbtn cardHeader' onClick={() => {
                            setShowDelete(!showDelete);
                        }}>{t("User Profile.Delete account")} </button>
                    </div>
                </div>
            </div>
            {showModal && (
                <WljOverlayModal>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className='setting-header d-flex justify-content-between align-items-center'>
                                <h6 className="wlj-modal-title--danger">
                                    <LockSharpIcon className="material-symbols-sharp" />
                                    {t("User Profile.Confirm to close account")}
                                </h6>
                                <CloseSharpIcon className="material-symbols-sharp me-2 pointer" onClick={closeModal}
                                />
                            </div>
                            <Form>
                                <div className='row p-4 settings'>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="Username">{t("User Profile.Current Password")} <span style={{ color: 'red' }}>*</span></label>
                                        <input type="password" />
                                    </div>
                                    <div className="col-md-12 ">
                                        <label htmlFor="about">{t("User Profile.Cause")}<span style={{ color: 'red' }}>*</span></label>
                                        <ReactSelect
                                            className="custom-select"
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                }),
                                            }}
                                            options={options}
                                            placeholder="Address Type"
                                        />
                                    </div>
                                    <div className="col-md-12 ">
                                        <label htmlFor="about"> {t("User Profile.Describe")} </label>
                                        <textarea id="about" name="about" rows="4" cols="50">
                                        </textarea>
                                    </div>
                                    <div className='text-end mt-4 d-flex justify-content-end wlj-modal-footer'>
                                        <button type="button" className="closebtn me-2" onClick={closeModal}>{t("Connections.Cancel")}</button>
                                        <button type="button" className="wljDangerBtn">
                                            <LockSharpIcon />
                                            {t("User Profile.Close account")}
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </WljOverlayModal>
            )
            }


            <WljConfirmModal
                show={show}
                title={t("User Profile.Are you sure you want to deactivate account")}
                icon={<WarningSharpIcon />}
                confirmLabel={t("User Profile.Deactivate")}
                onConfirm={() => DeactivateAcc()}
                onClose={DeactivateAccount}
            />

            <WljConfirmModal
                show={showDelete}
                title={t("User Profile.Are You Sure You want to Delete?")}
                icon={<DeleteOutlineSharpIcon />}
                confirmLabel={t("Drafts.Delete")}
                onConfirm={() => DeleteAcc()}
                onClose={DeleteAccount}
            />

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    )
}

export default Account